import { Component, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.css'],
})
export class OptionComponent implements OnChanges {
  @Input() required = false;
  @Input() type: 'radio' | 'checkbox' | 'toggle';
  @Input() name: string;
  @Input() tab = 1;
  @Input() note: string;
  @Input() label = '';
  @Input() optionLabel = '';
  @Input() buttonLabel = '';
  @Input() id = '';
  @Input() options: Array<any>;
  @Input() control = new FormControl();

  constructor() {}

  ngOnChanges(changes: any) {
    if (changes.control?.currentValue !== undefined && changes.options?.currentValue !== undefined) {
      this.setFormControl();
    }
  }

  onChanged(): void {
    this.control.markAsDirty();
  }

  onValueChanged(select: any): void {
    if (this.type === 'radio') {
      this.options = this.options.map((option) => {
        if (option.value === select.value && option.label === select.label) {
          option.selected = true;
        } else {
          option.selected = false;
        }
        return option;
      });
    }
    if (this.type === 'checkbox') {
      this.options
        .filter((option) => option.value === select.value && option.label === select.label)
        .map((option) => (option.selected === true ? (option.selected = false) : (option.selected = true)));
    }
    this.setFormControl();
  }

  setFormControl() {
    this.control.markAsDirty();
    const selected = this.options
      .filter((option) => option.selected === true)
      .map((option) => {
        return option.value;
      });
    this.control.setValue(selected);
    if (this.required === true) {
      if (selected.length === 0) {
        this.control.setErrors({ required: true });
      }
    } else {
      this.control.setErrors({ required: false });
      this.control.clearValidators();
    }
  }
}
